{
  "title": "Дети на Волге",
  "subtitle": "Двадцать дней по воде, пешком и через города Поволжья",
  "dates": "29 июля — 17 августа 2026",
  "startDate": "2026-07-29",
  "endDate": "2026-08-17",
  "status": "published",
  "routeNote": "Маршрут восстановлен по ежедневным отчётам. Пунктиром отмечены приблизительные участки.",
  "mapCenter": [49.55, 54.55],
  "mapZoom": 6.1
}
